import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunOutlined = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M8 2.194V1.178M3.895 12.106l-.719.718M8 14.822v-1.016m4.823-10.63-.718.719M13.805 8h1.017m-2.717 4.106.718.718M1.178 8h1.016m.982-4.824.718.718m6.58 1.631a3.5 3.5 0 1 1-4.949 4.95 3.5 3.5 0 0 1 4.95-4.95"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgSunOutlined;
